function getCardCount(item) {
  const rawCount = item && item.count;
  const count = rawCount ? Number(rawCount) : 1;

  return Number.isFinite(count) && count > 0 ? count : 1;
}

function getGroupKey(item) {
  const themeId = item && item.themeId != null ? String(item.themeId) : "";
  const chargeAmount =
    item && item.chargeAmount != null ? String(item.chargeAmount) : "";
  const showAmount =
    item && item.showAmount != null ? String(item.showAmount) : "";

  return themeId + "::" + chargeAmount + "::" + showAmount;
}

function groupGiftCardItems(orderItems) {
  const groups = [];
  const groupsByKey = Object.create(null);

  (orderItems || []).forEach((item) => {
    const key = getGroupKey(item);
    let group = groupsByKey[key];
    const count = getCardCount(item);

    if (!group) {
      group = {
        key,
        item,
        items: [],
        themeId: item && item.themeId,
        chargeAmount: item && item.chargeAmount,
        showAmount: item && item.showAmount,
        count: 0,
        successfulCount: 0,
        failedCount: 0,
      };
      groupsByKey[key] = group;
      groups.push(group);
    }

    group.items.push(item);
    group.count += count;
    if (item && item.chargeStatus === 1) group.successfulCount += count;
    else group.failedCount += count;
  });

  return groups;
}

module.exports = groupGiftCardItems;
